<div class="detail-content__categories" *ngIf="(categories?.hierarchicalProperties?.length > 0 || categories?.masterProperties?.length > 0)">
    <h3 *ngIf="unified?.length > 0" class="detail-content__categories-title bold">{{ 'CARD_DETAIL.CATEGORIES' | translate }}</h3>
    <div class="categories-container">
      <div class="category-item" *ngFor="let category of unified">
        <span>{{ _api(category?.translations, 'name') }}</span>
      </div>
    </div>
</div>